/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AttachPlanTaskRequestDto,
  ListPlanTasksResponseDto,
  PlanTaskResponseDto,
  ReorderPlanTasksRequestDto,
} from '../models/index';
import {
    AttachPlanTaskRequestDtoFromJSON,
    AttachPlanTaskRequestDtoToJSON,
    ListPlanTasksResponseDtoFromJSON,
    ListPlanTasksResponseDtoToJSON,
    PlanTaskResponseDtoFromJSON,
    PlanTaskResponseDtoToJSON,
    ReorderPlanTasksRequestDtoFromJSON,
    ReorderPlanTasksRequestDtoToJSON,
} from '../models/index';

export interface PlanTaskControllerAttachRequest {
    planId: string;
    attachPlanTaskRequestDto: AttachPlanTaskRequestDto;
}

export interface PlanTaskControllerDetachRequest {
    taskId: string;
    planId: string;
}

export interface PlanTaskControllerFindAllRequest {
    planId: string;
}

export interface PlanTaskControllerReorderRequest {
    planId: string;
    reorderPlanTasksRequestDto: ReorderPlanTasksRequestDto;
}

/**
 * 
 */
export class PreventiveMaintenancePlanTasksApi extends runtime.BaseAPI {

    /**
     */
    async planTaskControllerAttachRaw(requestParameters: PlanTaskControllerAttachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanTaskResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planTaskControllerAttach().'
            );
        }

        if (requestParameters['attachPlanTaskRequestDto'] == null) {
            throw new runtime.RequiredError(
                'attachPlanTaskRequestDto',
                'Required parameter "attachPlanTaskRequestDto" was null or undefined when calling planTaskControllerAttach().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/tasks`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttachPlanTaskRequestDtoToJSON(requestParameters['attachPlanTaskRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanTaskResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planTaskControllerAttach(requestParameters: PlanTaskControllerAttachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanTaskResponseDto> {
        const response = await this.planTaskControllerAttachRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planTaskControllerDetachRaw(requestParameters: PlanTaskControllerDetachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling planTaskControllerDetach().'
            );
        }

        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planTaskControllerDetach().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/tasks/{taskId}`;
        urlPath = urlPath.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters['taskId'])));
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async planTaskControllerDetach(requestParameters: PlanTaskControllerDetachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planTaskControllerDetachRaw(requestParameters, initOverrides);
    }

    /**
     */
    async planTaskControllerFindAllRaw(requestParameters: PlanTaskControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPlanTasksResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planTaskControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/tasks`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPlanTasksResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planTaskControllerFindAll(requestParameters: PlanTaskControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPlanTasksResponseDto> {
        const response = await this.planTaskControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planTaskControllerReorderRaw(requestParameters: PlanTaskControllerReorderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPlanTasksResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planTaskControllerReorder().'
            );
        }

        if (requestParameters['reorderPlanTasksRequestDto'] == null) {
            throw new runtime.RequiredError(
                'reorderPlanTasksRequestDto',
                'Required parameter "reorderPlanTasksRequestDto" was null or undefined when calling planTaskControllerReorder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/plans/{planId}/tasks/reorder`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReorderPlanTasksRequestDtoToJSON(requestParameters['reorderPlanTasksRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPlanTasksResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async planTaskControllerReorder(requestParameters: PlanTaskControllerReorderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPlanTasksResponseDto> {
        const response = await this.planTaskControllerReorderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
